import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/services/auth';
import db from '@/services/database';

Vue.use(Vuex);

let unsubscribeUserSnapshots = null;

const store = new Vuex.Store({

    state: {
        appStatus: 'loading',
        user: null,
        cart: {
            products: [],
            totalPrice: 0
        }
    },

    mutations: {
        changeAppStatus(state, status) {
            state.appStatus = status;
        },

        changeUser(state, user) {
            state.user = user;
        },

        changeProducts(state, products) {
            state.products = products;
        },

        changeProductsInCart(state, products) {
            state.cart.products = products;
            
            let totalPrice = 0;
            products.forEach((product) => {
                totalPrice += product.totalPrice;    
            });
            
            state.cart.totalPrice = totalPrice;
            
        }
    },

    actions: {
        userLogout() {
            if(unsubscribeUserSnapshots){
                unsubscribeUserSnapshots();
            }
            auth.signOut().then(() => {});
        },

        changeUser(context, firebaseUser) {
            
            let user = null

            if (firebaseUser) {
                try {

                    context.commit('changeAppStatus', 'loadingUserInfo');

                    user = {
                        uid: firebaseUser.uid,
                        displayName: firebaseUser.displayName,
                        email: firebaseUser.email,
                        phone: null,
                        accountType: 'client'
                    }

                    unsubscribeUserSnapshots = db.collection('users').doc(firebaseUser.uid).onSnapshot(snapshot => {
                        const userData = snapshot.data();
                        if(userData){
                            const userInState = context.state.user;
                            const newUser = Object.assign({}, userInState);
                            
                            newUser.accountType = userData.accountType;
                            newUser.phone = userData.phone;
                            context.commit('changeUser', newUser);
                        }
                    })

                } catch (e) {
                    console.error(e);
                }
            }

            context.commit('changeAppStatus', 'ok');
            context.commit('changeUser', user);
        },

        addProductToCart(context, product) {

            const cart = context.state.cart;
            const priceReference = parseInt(product.data.priceReference);
            const products = [];

            let productUpdated = false;
            cart.products.forEach((cartProduct) => {

                const newProduct = Object.assign({}, cartProduct);

                if (cartProduct.id === product.id) {
                    newProduct.quantity += priceReference;
                    newProduct.totalPrice = (newProduct.unitPrice / priceReference) * newProduct.quantity;
                    productUpdated = true;
                }

                products.push(newProduct);

            });

            if (!productUpdated) {
                products.push({
                    id: product.id,
                    quantity: priceReference,
                    unitPrice: parseFloat(product.data.price),
                    totalPrice: parseFloat(product.data.price),
                    productData: product.data
                });
            }

            context.commit('changeProductsInCart', products);

        },

        removeProductFromCart(context, product) {

            const priceReference = parseInt(product.data.priceReference);
            const cart = context.state.cart;
            const products = [];

            cart.products.forEach((cartProduct) => {
                const newProduct = Object.assign({}, cartProduct);
                if (cartProduct.id === product.id) {
                    newProduct.quantity -= priceReference;
                    newProduct.totalPrice = (newProduct.unitPrice / priceReference) * newProduct.quantity;
                }

                if(newProduct.quantity > 0){
                    products.push(newProduct);
                }
            });

            context.commit('changeProductsInCart', products);

        }

    },

    getters: {

        isLoading(state) {
            return state.appStatus !== 'ok';
        },

        user(state) {
            return state.user;
        },

        userLogged(state) {
            return state.user !== null;
        },
        
        isAdminUser(state){
            return state.user && state.user.accountType === 'admin';
        },

        productsInCart(state) {
            return state.cart.products;
        },

        totalCartPrice(state) {
            return state.cart.totalPrice
        }

    }
});


auth.onAuthStateChanged((user) => {
    store.dispatch('changeUser', user);
})

export default store;
